export default __webpack_public_path__ + "static/media/arrow-down.5af8e4f9.svg";